<template>
  <Notification
    :description="
      $t('rc_notification_connection_inactive', { ConnectivityProvider: providerName })
    "
    v-bind="$attrs"
  />
</template>

<script setup>
import { computed } from 'vue'
import Notification from '@/components/productNotifications/Notification.vue'

import { useConnectivityProviderName } from '@/composables/useConnectivityProviderName'

const props = defineProps({
  extraParameters: { type: Object, default: () => ({}) },
})
const { providerName } = useConnectivityProviderName(computed(() => props.extraParameters.partnerId))
</script>
